import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'extractFileName',
    pure: true
})
export class ExtractFileNamePipe implements PipeTransform {

    transform(value: string, args?: never): string {
        return this.getFileID(value);
    }

    /**
     * @returns the part after last / , before last . (filetype)
     */
    getFileID(url: string): string {
        const splits = url.split('/');
        const lastUrlSegment = splits.at(-1);
        return lastUrlSegment.replace('.pdf', '');
    }
}
